import {
  repairOriginal,
  type RepairBody,
} from "../content/lianxi/yufa-repair.js";
import type { GrammarTeaching } from "../content/lianxi/yufa-teaching.js";
import type { RepairAnswer } from "./yufa-marking.js";

/** Both markers resolve the selected span against the published pieces. */
export function repairAnswer(
  item: RepairBody & { readonly teaching?: GrammarTeaching },
  chosen: number,
  typed: string,
): RepairAnswer | undefined {
  if (!Number.isInteger(chosen) || chosen < 0 || chosen > item.pieces.length) {
    return undefined;
  }
  const noChange = chosen === item.pieces.length;
  const original = repairOriginal(item);
  if (!noChange && !typed.trim()) {
    return undefined;
  }
  return {
    kind: "repair",
    chosen,
    expected:
      item.diagnosis.kind === "no-change"
        ? item.pieces.length
        : item.diagnosis.at,
    typed: noChange ? original.simplified : typed.trim(),
    accepted: item.accepted.map((form) => form.simplified),
    other: item.accepted.map((form) => form.traditional),
    ...(item.teaching === undefined ? {} : { teaching: item.teaching }),
  };
}
